import {
    COMCASTLIVEAGENTSURVEY_LOAD,
    COMCASTLIVEAGENTSURVEY_UNLOAD,
    COMCASTLIVEAGENTSURVEY_SET,
} from '../../../actionDefinitions';

import {
    fetchLiveSurveys,
    fetchDomainValues,
    fetchAgentsOfTeamsOfTheUser
} from '../../../api/v3/DataApi';

export function loadComcastLiveAgentSurveyScreen() {
    return dispatch => {
        dispatch(loadLiveSurveys());
        dispatch(loadDomainValues());
        dispatch(loadAgentsOfTeamsOfTheUser());        
    };
}

export function loadLiveSurveys(selectedFilters) {
    return dispatch =>
        fetchLiveSurveys(selectedFilters)
            .then(payload => dispatch({ type: COMCASTLIVEAGENTSURVEY_LOAD, payload: { liveSurveys: payload.result } }))
            .catch(payload => dispatch({ type: COMCASTLIVEAGENTSURVEY_LOAD, error: true, payload }))
}

export function loadAgentsOfTeamsOfTheUser() {
    return dispatch =>
        fetchAgentsOfTeamsOfTheUser()
            .then(payload => dispatch({ type: COMCASTLIVEAGENTSURVEY_LOAD, payload: { agentsOfTeamsOfTheUser: payload.result } }))
            .catch(payload => dispatch({ type: COMCASTLIVEAGENTSURVEY_LOAD, error: true, payload }))
}

export function loadDomainValues() {
    return dispatch =>
        fetchDomainValues()
            .then(payload => dispatch({ type: COMCASTLIVEAGENTSURVEY_LOAD, payload: { domainValues: payload.result } }))
            .catch(payload => dispatch({ type: COMCASTLIVEAGENTSURVEY_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: COMCASTLIVEAGENTSURVEY_SET, updatedProps });
    }
}
